import { action } from "@ember/object"
import Component from "@glimmer/component"

interface Options {
  lessonCount: number
  foundDates: string[]
  rotationTitle: string
}

interface Sig {
  Args: {
    options: Options
    accept: (turnDatesOn: boolean) => void
    decline: () => void
  }
}

export default class AskToTurnDatesOn extends Component<Sig> {
  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      this.args.accept(true)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Dialogs::AskToTurnDatesOn": AskToTurnDatesOn
  }
}
